import PropTypes from "prop-types";
import { withTranslation } from "@template/components/translation";
import styles from "./index.css";
import LegacyBreadcrumbs from "./LegacyBreadcrumbs";
import { isFragmentationMode } from "../TemplateFragmentation/isFragmentationMode";

const Breadcrumbs = ({ formatTranslation }) => (
  <nav
    aria-label={formatTranslation("accessibility_breadcrumbs")}
    className={styles.container}
    dangerouslySetInnerHTML={{
      __html: "<!--%breadcrumbs%-->"
    }}
  />
);

Breadcrumbs.propTypes = {
  formatTranslation: PropTypes.func.isRequired
};

export default isFragmentationMode
  ? withTranslation(Breadcrumbs)
  : LegacyBreadcrumbs;
